module.exports = __webpack_public_path__ + "img/21.940a62ff.png";